import {
  DecisionEngineStatus,
  JOURNEY_CHANNEL_TYPE,
  JOURNEY_FLOW_TYPE,
} from "@hightouch/lib/customer-data/decision-engine/types";

import type { Flows } from "./types";

export function isActiveAgent(
  agent: Pick<Flows[number], "enabled" | "status" | "config">,
) {
  return (
    (agent.enabled && agent.status === DecisionEngineStatus.READY) ||
    agent.config.demo_data
  );
}

export function isOnsiteFlow(flow: Pick<Flows[number], "flow_type">): boolean {
  return flow.flow_type === "onsite";
}

export function isJourneyFlow(flow: Pick<Flows[number], "flow_type">): boolean {
  return flow.flow_type === JOURNEY_FLOW_TYPE;
}

export function isJourneyChannel(channel: { type: string }): boolean {
  return channel.type === JOURNEY_CHANNEL_TYPE;
}

type FeatureMatrixWithFlows = {
  flows: Pick<Flows[number], "flow_type">[];
};

function isJourneyFeatureMatrix(
  featureMatrix: FeatureMatrixWithFlows,
): boolean {
  return (
    featureMatrix.flows.length > 0 && featureMatrix.flows.every(isJourneyFlow)
  );
}

export function canViewFeatureMatrix(
  featureMatrix: FeatureMatrixWithFlows,
  isHightouchUser: boolean,
): boolean {
  return isHightouchUser || !isJourneyFeatureMatrix(featureMatrix);
}
